import React  from 'react';
import Classes from "classnames";

export default function renderCurrencyGroupListHeader(id, props) {
    const { data, className } = props;

    const cf = gd.session.customFields.get(id);
    const currencyId = cf.params ? cf.params.symbol : null;
    let currencyMark = '';

    const currency = _.find(_.values(gd.const.currency), c=>c.value === currencyId);
    if (currency) currencyMark = currency.symbol;

    const classes = Classes(className, 'gd-field-currency-group-list-header', {
        'no-value': !data.value
    });

    return (
        <div className={classes}>
            <div className="group-list-header-label">{data.value ? currencyMark : null}</div>
            <div className="group-list-header-value">{data.value ? data.value : "No value"}</div>
        </div>
    );
}